export const HUErrorCode = {
  Unauthorised: 0,
  TokenExpired: 1,
} as const

export type HUErrorCode = (typeof HUErrorCode)[keyof typeof HUErrorCode]

export class HUError extends Error {
  readonly code: HUErrorCode
  readonly status: number | undefined

  constructor(_code: HUErrorCode, message: string, status?: number) {
    super(message)
    this.code = _code
    this.status = status
  }
}
